import styled from 'styled-components';

import PrimaryButtonLoading from '../../../../shared/buttons/loadingButtons/PrimaryButtonLoading';

export const StyledForm = styled.form`
  margin-bottom: 75px;
`;

export const CreateScaleBtn = styled(PrimaryButtonLoading)`
  margin-left: 15px;
`;
